import { useTranslation } from "react-i18next";
import { makeStyles, Typography } from "@material-ui/core";
import { Pagination, Skeleton } from "@material-ui/lab";
import { RecipientsByEmailResponse } from "@dashboard-v3/api";
import RecipientDetails from "./RecipientDetails";
import { useEffect, useState } from "react";

interface Props {
  loading: boolean;
  recipients: RecipientsByEmailResponse;
}

const MAX_ITEMS = 15;

export default function RecipientsList(props: Props) {
  const { loading, recipients } = props;
  const { t } = useTranslation("emailFlowLogs");
  const [page, setPage] = useState(1);
  const classes = useStyles();
  const loaders = Array.from(Array(MAX_ITEMS).keys());
  const offset = (page - 1) * MAX_ITEMS;
  const totalPages = Math.ceil(recipients.length / MAX_ITEMS);
  const currentPageItems = [...recipients]
    .sort((a, b) => {
      const dateA = new Date(a.actionCreatedAt).getTime();
      const dateB = new Date(b.actionCreatedAt).getTime();
      return dateA - dateB;
    })
    .slice(offset, offset + MAX_ITEMS);

  useEffect(() => {
    setPage(1);
  }, [recipients]);

  return (
    <>
      <Typography style={{ marginTop: 40 }} variant="subtitle2">
        {t("recipientsDetails.title")}
      </Typography>

      <div className={classes.headerContainer}>
        <Typography className={classes.headerItem}>
          {t("recipientsDetails.columnTitle.emailAddress")}
        </Typography>
        <Typography className={classes.headerItem}>
          {t("recipientsDetails.columnTitle.latestStatus")}
        </Typography>
        <Typography className={classes.headerItem}>
          {t("recipientsDetails.columnTitle.latestStatusDate")}
        </Typography>
      </div>

      {loading && loaders.map(l => <Skeleton key={l} height={85} />)}

      {currentPageItems.map(item => (
        <RecipientDetails key={item.msgUID} details={item} />
      ))}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 15,
        }}
      >
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, newPage) => {
            setPage(newPage);
          }}
        />
      </div>
    </>
  );
}

const useStyles = makeStyles({
  headerContainer: {
    marginTop: 20,
    display: "grid",
    gridColumnGap: "20px",
    gridTemplateColumns: "1fr 1fr 1fr",
    padding: "0 16px 0 16px",
    alignItems: "center",
  },
  headerItem: {
    color: "grey",
    fontSize: "14px",
    fontWeight: 500,
  },
  accordion: { width: "100%", padding: "8px 5px" },
  dataContainer: {
    display: "grid",
    width: "100%",
    gridColumnGap: "20px",
    gridTemplateColumns: "1fr 1fr 1fr",
    alignItems: "center",
    padding: 0,
  },
});
